import React, {useState, useEffect} from 'react';
import {number_format} from "../../utils/formatter";

const RevenueTable = ({vendor, data}) => {
  const [all, setAll] = useState({});
  const [rest, setRest] = useState([]);
  const [spread, setSpread] = useState(false);

  const positionToLabel = {
    pc_content_upper: '본문 상단 PC',
    pc_content_middle: '본문 중간 PC',
    pc_content_lower: '본문 하단 PC',
    mo_content_upper: '본문 상단 모바일',
    mo_content_middle: '본문 중간 모바일',
    mo_content_lower: '본문 하단 모바일',
    sidebar: '사이드바',
    pc_list_upper: '목록 상단 PC',
    pc_list_lower: '목록 하단 PC',
    mo_list_upper: '목록 상단 모바일',
    mo_list_lower: '목록 하단 모바일',
  };
  const order = ['pc_content_upper', 'mo_content_upper', 'pc_content_middle', 'mo_content_middle', 'pc_content_lower',
    'mo_content_lower', 'sidebar', 'pc_list_upper', 'mo_list_upper', 'pc_list_lower', 'mo_list_lower',
  ];

  useEffect(() => {
    if (data && data.length > 0) {
      setAll(data.filter((e) => e.id === 'all')[0]);
      const rest = [];
      order.forEach((position) => {
        rest.push(data.find(e => e.position === position))
      });
      setRest(rest);
    }
  }, [data]);
  return (
    <div className="box_blog wrap_tbl">
      <table className="tbl_tistory tbl_tistory_type2">
        <colgroup>
          <col width="193"/>
          <col width="173"/>
          <col width="173"/>
          <col width="173"/>
        </colgroup>
        <tbody>
        <tr>
          <th scope="col">광고 위치</th>
          <th scope="col">노출수</th>
          <th scope="col">클릭수</th>
          {vendor === 'adsense' &&
          <th scope="col">노출 RPM</th>
          }
          {vendor === 'adfit' &&
          <th scope="col">eCPM</th>
          }
          <th scope="col">수익</th>
        </tr>
        {data &&
        <>
          <tr>
            <th scope="row" className="th_row td_total">전체
              {vendor === 'adfit' && !spread &&
              <button className="btn_type7 btn_type7_type1" onClick={()=>setSpread(true)}>열기</button>
              }
              {vendor === 'adfit' && spread &&
              <button className="btn_type7" onClick={()=>setSpread(false)}>접기</button>
              }
            </th>
            <td className="td_total">{number_format(all.impression)}</td>
            <td className="td_total">{number_format(all.clicks)}</td>
            <td className="td_total">{number_format(all.rpm)}</td>
            <td className="td_total">{number_format(all.earnings)}</td>
          </tr>
          {spread && rest.map(ele =>
            <tr key={ele.position}>
              <th scope="row" className="th_row">{positionToLabel[ele.position]}</th>
              <td>{number_format(ele.impression)}</td>
              <td>{number_format(ele.clicks)}</td>
              <td>{number_format(ele.rpm)}</td>
              <td>{number_format(ele.earnings)}</td>
            </tr>
          )}
        </>
        }
        </tbody>
      </table>
    </div>
  )
};

export default RevenueTable;